<template>
  <div id="tabletennistable" class="mt-3 mb-3 text-center">
    <svg height="170" width="275" >
        <defs>
            <marker id="inarrowhead" refX="0" refY="1"
              markerWidth="2" markerHeight="2" orient="auto">
                <path d="M 0,0 V 2 L2,1 Z" fill="#FFFFFF"></path>
            </marker>
            <marker id="outarrowhead" refX="0" refY="1"
              markerWidth="2" markerHeight="2" orient="auto">
                <path d="M 0,0 V 2 L2,1 Z" fill="#dc3545"></path>
            </marker>
        </defs>
        <rect x="0" y="0" width="274" height="152" fill="#FFFFFF"
            stroke="#000000" stroke-width="1" transform="translate(0,10)"/>
        <rect x="0" y="0" width="264" height="142" fill="#42A5F5"
            transform="translate(5,15)"/>
        <line x1="137" y1="0" x2="137" y2="140" stroke="#ffffff"
            stroke-width="3" stroke-linecap="round" transform="translate(0,15)"/>
        <line x1="0" y1="76" x2="274" y2="76" stroke="#ffffff"
            stroke-width="1" stroke-linecap="round" transform="translate(0,15)"/>
        <!-- ここからラリーの描画 -->
        <line v-for="(attack, index) in rally"
            :x1="attack.x1" :y1="attack.y1" :x2="(attack.x2 - attack.x1) * 0.9 + attack.x1"
            :y2="(attack.y2 - attack.y1) * 0.9 + attack.y1"
            :stroke="attack.stroke" stroke-width="5" stroke-linecap="round"
            fill-opacity="0.5" transform="translate(5,10)"
            :marker-end="attack.marker" :key="index+'arrow'"/>
        <text v-for="(attack, index) in rally"
            :x="(attack.x2 + attack.x1) / 2"
            :y="(attack.y2 + attack.y1) / 2"
            transform="translate(5,10)"
            opacity="0.5" :key="index+'text'">
            {{ attack.idx }}
        </text>
    </svg>
    <div class="mt-3">
      <div class="d-inline">開始</div>
      <b-form-input class="w-25 d-inline" v-model.number="startIdx"
        type="number">
        {{ startIdx }}
      </b-form-input>
      <b-button class="ml-3" variant="primary" @click="startIdx+=1"
        :disabled="endIdx <= startIdx">
        <font-awesome-icon icon="plus"/>
      </b-button>
      <b-button class="ml-3" variant="primary" @click="startIdx-=1"
      :disabled="startIdx <= 1">
        <font-awesome-icon icon="minus"/>
      </b-button>
    </div>
    <div class="mt-3">
      <div class="d-inline">終了</div>
      <b-form-input class="w-25 d-inline" v-model.number="endIdx"
        type="number">
        {{ endIdx }}
      </b-form-input>
      <b-button class="ml-3" variant="primary" @click="endIdx+=1"
        :disabled="endIdx >= label+1">
        <font-awesome-icon icon="plus"/>
      </b-button>
      <b-button class="ml-3" variant="primary" @click="endIdx-=1"
        :disabled="startIdx >= endIdx">
        <font-awesome-icon icon="minus"/>
      </b-button>
    </div>
    <details class="mt-3">
      <summary>左右逆になっている場合</summary>
      利き手の設定を新しく追加しました。設定<font-awesome-icon icon="wrench"/>から利き手の設定を行ってください。
    </details>
  </div>
</template>

<script>
import CmnConst from '@/lib/cmnConst';

export default {
  name: 'table',
  props: ['hits', 'label', 'gameInfo'],
  data() {
    return {
      startIdx: 1,
      endIdx: this.label + 1,
      CmnConst,
      table_x: 274,
      table_y: 152,
      position: [
        {
          x: 0.25,
          y: -1,
        }, {
          x: 0.25,
          y: 1,
        }, {
          x: 0.25,
          y: -0.5,
        }, {
          x: 0.25,
          y: 0.5,
        }, {
          x: 0.25,
          y: 0,
        }, {
          x: 1,
          y: 0,
        }, {
          x: 1,
          y: -1,
        }, {
          x: 1,
          y: 1,
        }, {
          x: 0.75,
          y: -1,
        }, {
          x: 0.75,
          y: 1,
        },
      ],
    };
  },
  computed: {
    rally() {
      const ret = this.createRally(this.hits.player, this.hits.hitPosition,
        this.hits.course, this.hits.isServe, this.hits.inOut,
        this.gameInfo.player1Hand, this.gameInfo.player2Hand);
      return ret.filter(value => this.startIdx <= value.idx && value.idx <= this.endIdx);
    },
  },
  watch: {
    hits() {
      this.endIdx = this.label + 1;
    },
  },
  methods: {
    createRally(player, hitPosition, course, isServe, inOut, player1Hand, player2Hand) {
      let ret = [];
      let preX = 0;
      let preY = 0;
      for (let i = 0; i < player.length; i++) {
        let hit = {};
        const nowHand = player[i] === 1 ? player1Hand : player2Hand;
        const nextHand = player[i] === 2 ? player1Hand : player2Hand;
        if (isServe[i]) {
          ret = [];
          preX = this.getPositionAtServe(hitPosition[i], player[i], nowHand).x;
          preY = this.getPositionAtServe(hitPosition[i], player[i], nowHand).y;
        }
        hit = this.getPosition(course[i], player[i], nextHand);
        hit.x1 = preX;
        hit.y1 = preY;
        // 色の編集
        if (!inOut[i]) {
          hit.stroke = '#DC3545';
          hit.marker = 'url(#outarrowhead)';
        } else {
          hit.stroke = '#FFFFFF';
          hit.marker = 'url(#inarrowhead)';
        }
        // 打球情報
        // if (isServe[i]) {
        //   hit.hitsStyle = this.CmnConst.serveList[hitStyle[i]];
        // } else {
        //   hit.hitsStyle = this.CmnConst.hitsStyleList[hitStyle[i]];
        // }
        hit.idx = ret.length + 1;
        ret.push(hit);
        preX = hit.x2;
        preY = hit.y2;
      }
      return ret;
    },
    getPosition(idx, player, hand) {
      const ret = {};
      const flg1 = player === 1 ? -1 : 1;
      const flg2 = player === 2 ? -1 : 1;
      let handFlg = 1;
      if (hand) {
        handFlg = -1;
      }
      ret.x2 = ((this.position[idx].x * this.table_x * flg2) / 2) + (this.table_x / 2);
      ret.y2 = (((this.position[idx].y * this.table_y * flg1) * handFlg) / 2) + (this.table_y / 2);
      return ret;
    },
    getPositionAtServe(idx, player, hand) {
      const ret = {};
      if (idx === 0) {
        ret.x = this.position[6].x;
        ret.y = this.position[6].y;
      } else if (idx === 1) {
        ret.x = this.position[5].x;
        ret.y = this.position[5].y;
      } else if (idx === 2) {
        ret.x = this.position[7].x;
        ret.y = this.position[7].y;
      } else {
        throw new Error();
      }
      if (hand) {
        ret.y *= -1;
      }
      if (player === 1) {
        ret.x = ((ret.x * this.table_x * -1) / 2) + (this.table_x / 2);
        ret.y = ((ret.y * this.table_y) / 2) + (this.table_y / 2);
      } else if (player === 2) {
        ret.x = ((ret.x * this.table_x) / 2) + (this.table_x / 2);
        ret.y = ((ret.y * this.table_y * -1) / 2) + (this.table_y / 2);
      } else {
        throw new Error();
      }
      return ret;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/molecules/TableTennisTable.vue